import { render, staticRenderFns } from "./SettingsPrintersPage.vue?vue&type=template&id=31923a9a&scoped=true"
import script from "./SettingsPrintersPage.vue?vue&type=script&lang=js"
export * from "./SettingsPrintersPage.vue?vue&type=script&lang=js"
import style0 from "./SettingsPrintersPage.vue?vue&type=style&index=0&id=31923a9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31923a9a",
  null
  
)

export default component.exports